import React from "react";
import { PanelEditCategory } from "../../../UI/Categories/Edit/PanelEditCategory";


const EditCategory = () => {
  return (
    <div>
      <PanelEditCategory />
    </div>
  );
};

export default EditCategory;
